/*
  assets/chk-gift-review.js
  ギフトLP「ブランド紹介」の口コミ本文（<chk-gift-review-body>）。
  本文が4行（CSSの line-clamp）を超えるときだけ「続きを読む」ボタンを出し、押すと全文を開閉する。
  - JSが動かない環境では省略しない（data-clamp を付けたときだけCSSで省略する）。
  - カード幅が変わる（回転・リサイズ）と行数も変わるため、ResizeObserver で判定し直す。
*/
if (!customElements.get('chk-gift-review-body')) {
  class ChkGiftReviewBody extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.chk-gift-review__body');
      this.button = this.querySelector('.chk-gift-review__more');
      if (!this.body || !this.button) return;

      this.setAttribute('data-clamp', '');
      this.button.addEventListener('click', () => this.toggle());
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.body);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    // 省略中に本文があふれているか（開いている間は判定しない）
    update() {
      if (this.hasAttribute('data-expanded')) return;
      const overflowing = this.body.scrollHeight > this.body.clientHeight + 1;
      this.button.hidden = !overflowing;
    }

    toggle() {
      const expanded = this.toggleAttribute('data-expanded');
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.textContent = expanded ? '閉じる' : '続きを読む';
    }
  }

  customElements.define('chk-gift-review-body', ChkGiftReviewBody);
}
